import "./PolicyPages.css"

export default function TermsAndConditions() {
  return (
    <div className="policy-container">
      <div className="policy-content">
        <h1>Terms and Conditions</h1>
        <p className="last-updated">Last Updated: April 7, 2025</p>

        <section className="policy-section">
          <h2>1. Introduction</h2>
          <p>
            Welcome to our website. These Terms and Conditions govern your use of our website and services. By accessing
            or using our website, you agree to be bound by these Terms.
          </p>
        </section>

        <section className="policy-section">
          <h2>2. Definitions</h2>
          <p>
            <strong>"We", "Us", "Our"</strong> refers to our company.
            <br />
            <strong>"Website"</strong> refers to our website and all related pages.
            <br />
            <strong>"User", "You", "Your"</strong> refers to any individual accessing or using our website.
          </p>
        </section>

        <section className="policy-section">
          <h2>3. Account Registration</h2>
          <p>
            To access certain features of our website, you may need to create an account. You are responsible for
            maintaining the confidentiality of your account information and for all activities that occur under your
            account.
          </p>
        </section>

        <section className="policy-section">
          <h2>4. Products and Services</h2>
          <p>
            We strive to provide accurate descriptions of our products and services. However, we do not warrant that
            product descriptions or other content on the website are accurate, complete, reliable, current, or
            error-free.
          </p>
        </section>

        <section className="policy-section">
          <h2>5. Pricing and Payment</h2>
          <p>
            All prices are subject to change without notice. We reserve the right to refuse or cancel orders at any
            time. Payment must be made at the time of order through our secure payment system.
          </p>
        </section>

        <section className="policy-section">
          <h2>6. Intellectual Property</h2>
          <p>
            All content on this website, including text, graphics, logos, images, and software, is our property or the
            property of our licensors and is protected by copyright and other intellectual property laws.
          </p>
        </section>

        <section className="policy-section">
          <h2>7. User Conduct</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use the website for any illegal purpose</li>
            <li>Violate any applicable laws or regulations</li>
            <li>Interfere with the proper functioning of the website</li>
            <li>Attempt to gain unauthorized access to any part of the website</li>
            <li>Use the website to transmit harmful code or materials</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>8. Limitation of Liability</h2>
          <p>
            To the fullest extent permitted by law, we shall not be liable for any indirect, incidental, special,
            consequential, or punitive damages, including loss of profits, data, or goodwill, arising from your use of
            or inability to use the website.
          </p>
        </section>

        <section className="policy-section">
          <h2>9. Indemnification</h2>
          <p>
            You agree to indemnify and hold us harmless from any claims, damages, liabilities, costs, or expenses
            arising from your use of the website or violation of these Terms.
          </p>
        </section>

        <section className="policy-section">
          <h2>10. Modifications</h2>
          <p>
            We reserve the right to modify these Terms at any time. Your continued use of the website after any changes
            indicates your acceptance of the modified Terms.
          </p>
        </section>

        <section className="policy-section">
          <h2>11. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of [Your Jurisdiction], without
            regard to its conflict of law provisions.
          </p>
        </section>

        <section className="policy-section">
          <h2>12. Contact Information</h2>
          <p>If you have any questions about these Terms, please contact us at:</p>
          <p>
            Email: terms@example.com
            <br />
            Phone: (123) 456-7890
          </p>
        </section>
      </div>
    </div>
  )
}

